<template>
  <div id="auth_page" class="row white w-100 h-100 align-items-center">
    <div class="col-12 col-md-5 auth">
      <div class="content">
        <img src="@/assets/images/logo.png" id="logo" />

        <form @submit.prevent="submit">
            <h5 v-if="!showCodeInput" class="mb-4 text-center">Escolha o tipo de conta</h5>
            
            <div v-if="!showCodeInput" class="nav nav-pills nav-justified nav-pills--brand m--margin-top-20">
              <div class="nav-item">
                <a 
                  class="nav-link" 
                  :class="{ 'show': accountType === 'redator' }" 
                  @click="accountType = 'redator'"
                  href="#"
                >
                  Redator
                </a>
              </div>
              <div class="nav-item">
                <a 
                  class="nav-link" 
                  :class="{ 'show': accountType === 'publisher' }" 
                  @click="accountType = 'publisher'"
                  href="#"
                >
                  Publisher
                </a>
              </div>
          </div>

          <div v-if="accountType === 'redator'" class="tab-content mt-4">
            <p>
              A i7 Network tem o compromisso de zelar e atender bem os parceiros que já fazem parte da nossa comunidade.<br /><br />Assim, devido à alta demanda de colaboradores, não estamos aceitando novos cadastros de redatores em nossa lista de espera.
            </p>
          </div>

          <div v-if="accountType === 'publisher'" class="tab-content mt-4">
            <div v-if="!showCodeInput">
              <p class="mb-4">
                Preencha seus dados abaixo, que avisaremos, em breve, por e-mail, se seu cadastro foi aprovado.
              </p>

              <InputText
                name="name"
                label="Nome completo"
                v-model="registerForm.name"
                :error="formErrors.name"
                class="mb-3"
              />

              <InputText
                name="email"
                label="E-mail"
                type="email"
                v-model="registerForm.email"
                :error="formErrors.email"
                class="mb-3"
              />

              <InputText
                name="phone"
                label="Telefone"
                mask="(##) #####-####"
                v-model="registerForm.phone"
                :error="formErrors.phone"
                class="mb-3"
              />

              <div class="doc_type mb-3">
                <label class="mb-2">Tipo de documento</label>

                <div class="form-group m-radio-inline">
                  <label class="m-radio m-radio--focus">
                    <input
                      type="radio"
                      name="document_type"
                      value="cpf"
                      v-model="registerForm.document_type"
                    />
                    CPF
                    <span></span>
                  </label>

                  <label class="m-radio m-radio--focus">
                    <input
                      type="radio"
                      name="document_type"
                      value="cnpj"
                      v-model="registerForm.document_type"
                    />
                    CNPJ
                    <span></span>
                  </label>
                </div>

                <InputText
                  name="cpf_cnpj"
                  :mask="registerForm.document_type === 'cpf' ? '###.###.###-##' : '##.###.###/####-##'"
                  v-model="registerForm.cpf_cnpj"
                  :error="formErrors.cpf_cnpj"
                />
              </div>

              <p class="contact-info">
                Problemas em realizar seu cadastro? Entre em contato pelo e-mail: contato@i7.network
              </p>
            </div>

            <div v-else class="code-verification">
              <p class="mb-4 text-center">
                Digite o código recebido em seu telefone informado
              </p>

              <InputText
                name="code"
                label="Código de verificação"
                v-model="registerForm.code"
                :error="formErrors.code"
                maxlength="6"
                class="mb-3"
              />

              <div v-if="resendTimer > 0" class="resend-timer text-center mb-3">
                Você poderá reenviar o código em: <span class="timer">{{ resendTimer }}</span>
              </div>

              <div v-else class="text-center mb-3">
                <button
                  type="button"
                  @click="resendCode"
                  class="resend-button"
                  :disabled="loading"
                >
                  Reenviar código
                </button>
              </div>
            </div>

            <PrimaryButtonLoader v-if="loading" class="w-100 d-block mt-4"></PrimaryButtonLoader>
            <PrimaryButton v-else type="submit" class="w-100 d-block mt-4">
              {{ showCodeInput ? 'Continuar' : 'Enviar' }}
            </PrimaryButton>
          </div>

          <p v-if="error" class="error-message mt-3">{{ errorMessage }}</p>
        </form>

        <div class="mt-4 text-center">
          <router-link :to="{ 'name': 'login'}">
            <p class="back-to-login">Voltar ao login</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="col h-100 register">
      <div class="content">
        <h1 class="mb-4">i7 Network | 10 anos</h1>
        <p>
          Unindo vozes, criando conexões, ampliando informações e impulsionando conquistas.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useToast, TYPE } from "vue-toastification"
import InputText from '@/components/InputText.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import PrimaryButtonLoader from '@/components/PrimaryButtonLoader.vue'
import { errorFormat } from "@/utils/errorFormat"
import { authService } from '@/services/authService'

const loading = ref(false)
const error = ref(false)
const errorMessage = ref('')

const accountType = ref('publisher')
const registerForm = ref({ 
  name: '', 
  email: '', 
  phone: '', 
  document_type: 'cpf',
  cpf_cnpj: '',
  type: 'Publisher',
  code: ''
})
const router = useRouter()
const toast = useToast()

const formErrors = ref({})
const showCodeInput = ref(false)
const resendTimer = ref(0)
const resendInterval = ref(null)

const startResendTimer = () => {
  resendTimer.value = 60
  resendInterval.value = setInterval(() => {
    resendTimer.value--
    if (resendTimer.value <= 0) {
      clearInterval(resendInterval.value)
    }
  }, 1000)
}

const resendCode = async () => {
  loading.value = true
  error.value = false
  formErrors.value = {}

  try {
    const resendData = { ...registerForm.value, type: 'resend_code' }
    const response = await authService.register(resendData)

    if (response.data.status === 'resended') {
      startResendTimer()
    }
  } catch (err) {
    error.value = true
    errorMessage.value = 'Erro ao reenviar código. Tente novamente.'
  }

  loading.value = false
}

const submit = async () => {
  if (accountType.value === 'redator') {
    return
  }

  formErrors.value = {}
  loading.value = true
  error.value = false

  try {
    if (showCodeInput.value) {
      registerForm.value.type = 'code_check'
    } else {
      registerForm.value.type = accountType.value === 'publisher' ? 'Publisher' : 'Redator'
    }
    
    const response = await authService.register(registerForm.value)
    
    if (response.data.status === 'success_code') {
      showCodeInput.value = true
      startResendTimer()
      registerForm.value.type = 'code_check'
    } else if (response.data.status === 'success') {
      // Exibir mensagem de sucesso
      toast('Cadastro efetuado. Agradecemos o seu interesse. Enviaremos um convite para seu e-mail assim que surgirem novas vagas. Até lá!', { 
        type: TYPE.SUCCESS, 
        timeout: 10000 
      })
      
      router.push({ 
        name: 'login'
      })
    }
  } catch (err) {
    if (err.response && err.response.data && err.response.data.errors) {
      formErrors.value = errorFormat(err.response.data.errors)
    } else if (err.response && err.response.data === 'invalid-code') {
      error.value = true
      errorMessage.value = 'Código inválido'
    } else {
      error.value = true
      errorMessage.value = 'Erro ao processar cadastro. Tente novamente.'
    }
  }
  
  loading.value = false
}
</script>
<style>
body {
  background-color: #fff !important;
}</style>
<style scoped>
.m-login__head {
  text-align: center;
  margin-bottom: 20px;
}

.nav-pills {
  display: flex;
  gap: 10px;
  background-color: #f8f9fa;
  padding: 5px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.nav-item {
  flex: 1;
}

.nav-link {
  display: block;
  padding: 10px 15px;
  text-align: center;
  color: #6c757d;
  text-decoration: none;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.nav-link:hover {
  color: #583a8e;
  text-decoration: none;
}

.nav-link.show {
  background-color: #583a8e;
  color: white;
}

.tab-content {
  text-align: left;
}

.tab-content p {
  color: #6c757d;
  line-height: 1.5;
  margin-bottom: 20px;
}

.doc_type label {
  display: flex;
  font-weight: 500;
  margin-bottom: 8px;
}

.m-radio-inline {
  display: flex;
  gap: 20px;
}

.m-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
}

.m-radio input[type="radio"] {
  margin-right: 8px;
  width: 18px;
  height: 18px;
}

.contact-info {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 20px;
}

.error-message {
  color: #df2b2b;
  font-weight: 500;
  text-align: center;
}

.back-to-login {
  color: #583a8e;
  font-weight: 500;
  cursor: pointer;
  margin: 0;
}

.back-to-login:hover {
  text-decoration: underline;
}

.dark .nav-pills {
  background-color: #232932;
}

.dark .nav-link {
  color: #8c91a8;
}

.dark .nav-link:hover {
  color: #b5b9d0;
}

.dark .nav-link.show {
  background-color: #655582;
  color: white;
}

.dark .tab-content p,
.dark .contact-info {
  color: #8c91a8;
}

.dark .back-to-login {
  color: #b5b9d0;
}

.code-verification {
  text-align: center;
}

.resend-timer {
  color: #6c757d;
  font-size: 14px;
}

.timer {
  font-weight: 600;
  color: #583a8e;
  font-size: 16px;
}

.resend-button {
  background: none;
  border: none;
  color: #583a8e;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: 14px;
}

.resend-button:hover {
  color: #422872;
}

.resend-button:disabled {
  color: #6c757d;
  cursor: not-allowed;
  text-decoration: none;
}

.dark .timer {
  color: #b5b9d0;
}

.dark .resend-timer {
  color: #8c91a8;
}

.dark .resend-button {
  color: #b5b9d0;
}

.dark .resend-button:hover {
  color: #d1d8e8;
}
</style>